import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { PaymentMethod } from '../../loan/Payments';
import { zodBrandedString } from '../../utils';
import { Checkbox, DateString, NonNegativeMonetaryValue } from '../fields';

export const BulkPaymentMethod = z.enum([
  PaymentMethod.enum.check,
  PaymentMethod.enum.phone,
  PaymentMethod.enum.creditCard,
  PaymentMethod.enum.debitCard,
  PaymentMethod.enum.wire,
  PaymentMethod.enum.reserve,
]);

export const RecordPaymentRow = z.object({
  loanId: zodBrandedString<LosId>(),
  paymentMethod: BulkPaymentMethod.default('check'),
  paymentDate: DateString,
  processedDate: DateString.optional(),
  totalPaymentAmount: NonNegativeMonetaryValue,
  additionalPrincipalAmount: NonNegativeMonetaryValue.default(0),
  additionalEscrowAmount: NonNegativeMonetaryValue.default(0),
  additionalSuspenseAmount: NonNegativeMonetaryValue.default(0),
  // This will be hooked up in a future PR
  // paymentPayer: z.string().optional(),
  sendPaymentNotificationFlag: Checkbox.default(true),
  referenceId: z.string().optional(),
});

export const RECORD_PAYMENT_ROW_REQUIRED_FIELDS = Object.keys(RecordPaymentRow.shape).filter(
  (key) => !RecordPaymentRow.shape[key as keyof typeof RecordPaymentRow.shape].isOptional(),
);
